import { useState, useEffect } from "react"
const useMobileDevice = () => {
  const [ismobile, setMobile] = useState(false)

  useEffect(() => {
    if (window && window.matchMedia("screen and (max-width: 768px)").matches) {
      setMobile(true)
    } else {
      setMobile(false)
    }
  }, [])

  return ismobile
}

export { useMobileDevice }
export default useMobileDevice
